import { render, staticRenderFns } from "./imageGroupItem.vue?vue&type=template&id=22ca40dd"
import script from "./imageGroupItem.vue?vue&type=script&lang=js"
export * from "./imageGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports